import { InputProps } from '@chakra-ui/react';
import React from 'react';

import {
  CmFormControl,
  CmFormLabelWithQuestionIcon,
  CmInput,
  CmLeftIconAndInput,
} from '@/components/uiParts';

interface Props extends InputProps {
  fontWeight?: 'normal' | 'bold';
  isRequired?: boolean;
  label: string;
  id?: string;
  icon?: '' | 'search';
  question?: string;
}

export const CmLabelWithQuestionIconAndInput: React.FC<Props> = ({
  fontWeight = 'normal',
  isRequired = false,
  isInvalid = false,
  label,
  id = '',
  icon,
  borderColor = 'inherit',
  width = 'full',
  children,
  question,
  ...rest
}) => {
  const props = {
    isRequired,
    id,
    borderColor,
    ...rest,
  };
  return (
    <CmFormControl {...{ width, isInvalid }}>
      <CmFormLabelWithQuestionIcon
        htmlFor={id}
        {...{ isRequired, fontWeight, question }}
      >
        {label}
      </CmFormLabelWithQuestionIcon>
      {icon ? (
        <CmLeftIconAndInput {...{ ...props, icon }} />
      ) : (
        <CmInput {...{ ...props }} />
      )}
      {children}
    </CmFormControl>
  );
};
